const product = window.conviva.module || 'EI';

const ALL_METRICS = 'all_metrics';
// EI feature flags
const METRICS = 'metrics';
const VIEWER_DRILLDOWN = 'viewer-drilldown';
const VIEWER_DRILLDOWN_DISTRIBUTION = 'viewer-drilldown-distribution';
const VIEWER_DRILLDOWN_REST_METRICS = 'viewer-drilldown-rest-metrics';
const DISTRIBUTION_METRICS = 'distribution-metrics';
const DISTRIBUTION_METRICS_DRILLDOWN = 'distribution-metrics-drilldown';
const VIEWER_DRILLDOWN_TIMELINE = 'viewer-drill-down-timeline';
const AI_ALERTS = 'ai_alerts';
const DISABLE_THRESHOLD = 'disable-threshold';
const ALERT_DIAGNOSTICS = 'alert-diagnostics';
const BUSINESS_ERROR_METRIC = 'business_error_metrics';
const BUSINESS_ERROR_CONFIG = 'error_logic_configuration';
const TOP_RISING_CONTENT = 'top_rising_content';
const UNIFIED_AD_CONTENT_OVERVIEW = 'unified-ad-content-overview';
const ENABLE_2019_CHANGES = 'enable_2019_changes';
const SHOW_NINETY_DAYS_HISTORY = 'show_ninety_days_history';
const VIEWER_MODULE_PULSE5 = 'viewer-module-pulse5';
const AUTO_INSIGHTS = 'auto-insights';
const VIEWERS_OVERVIEW = 'viewers-overview';
const VIEWERS_BROWSER_TAB = 'viewers-browser-tab';
const ANNOTATIONS = 'annotations';
const HORIZONTAL_LAYOUT = 'horizontal-layout';
const PUBLIC_SAVED_DASHBOARDS = 'public-saved-dashboards';
const REALTIME_PSD = 'realtime-psd';
const AI_ROADMAP = 'ai-roadmap-dashboard';
const EI_PAGERDUTY = 'ei-pagerduty-enabled';
const VIEWER_MODULE_AI_SUMMARY = 'video-viewer-module-ai-summary';
const NEXA_EI = 'nexa-ei';
const NEXA_VIEWER = 'nexa-viewer';

// AI feature flags
const AD_METRICS = 'ad_metrics';
const AD_VIEWER_DRILLDOWN = 'ad-viewer-drilldown';
const AD_VIEWER_DRILLDOWN_DISTRIBUTION = 'ad-viewer-drilldown-distribution';
const AD_VIEWER_DRILLDOWN_REST_METRICS = 'ad-viewer-drilldown-rest-metrics';
const AD_DISTRIBUTION_METRICS = 'ad-distribution-metrics';
const AD_DISTRIBUTION_METRICS_DRILLDOWN = 'ad-distribution-metrics-drilldown';
const AD_VIEWER_DRILLDOWN_TIMELINE = 'ad-viewer-drill-down-timeline';
const AD_AI_ALERTS = 'ad_ai_alerts';
const AD_DISABLE_THRESHOLD = 'ad-disable-threshold';
// APP Insights feature flags
const APP_METRICS = 'app_metrics';
const APP_EXPERIENCE = 'app-experience';
const APP_USER_TIMELINE = 'app-user-timeline';
const APP_EXPERIENCE_BACKEND = 'app-experience-backend';
const APP_RT_ON_TRENDS = 'app-insights-realtime-on-trends';
const APP_EXPERIENCE_SAVE_AND_SHARE = 'app-experience-save-and-share-ff';
const APP_INSIGHTS_DISTRIBUTION = 'app-insights-distribution';
const APP_INSIGHTS_METRIC_FILTERING = 'app-insights-metric-filtering';
const APP_SPI = 'app-spi';
const AUDIENCE_ENGAGEMENT_METRICS = 'eco-audience-engagement';
const DISPLAY_PAGERDUTY_IN_SI = 'service-integration-pagerduty-enabled-feature';

const APP_CREATE_FILTER = 'app-create-filter';
const APP_TOP_RISING_CONTENT = 'app-top-rising-content';
const APP_DRILLDOWN_LIMIT = 'app-drilldown-limit';
const APP_DISABLE_THRESHOLD = 'app-disable-threshold';
const DECODED_STACK_TRACE = 'decoded-stack-trace';
const ECO_NETWORK_REQUEST_RCA = 'eco-network-request-rca';
const ECO_DATA_ACCESS_MONTHS = 'eco-data-access-months';
const ECO_AI_ALERT_2 = 'eco-ai-alert-2.0';
const ECO_AI_ALERT_MINS_WITH_X_METRICS = 'ai-alert-mins-with-x-metrics';
const DPI_AI_ALERTS_CUSTOM_DIMENSIONS_PER_METRIC_LIMIT =
  'dpi-ai-alerts-custom-dimensions-per-metric-limit';
const SELF_SERVE = 'self-serve';
const SELF_SERVE_INTEGRATION_STATUS = 'eco_self_serve_integration_status';
const NEXA_APP = 'nexa-app';

// common
const CUSTOM_TAGS = 'custom-tags';
const SAVED_DASHBOARDS = 'saved-dashboards';
const ERROR_DIAGNOSTICS = 'error-diagnostics';
const DAY_OVER_DAY = 'dod';
const SHARE = 'share';
const COMPARE = 'compare';
const COMBINATORIAL_FILTER = 'combinatorial-filter';
const ENUMERATED_VALUES_PER_DIMENSION = 'enumerated-values-per-dimension';
const DATA_ACCESS_DURATION = 'data-access-duration';
const ERROR_CODES_LIMIT = 'error-codes-limit';
const TRENDS_DIAGNOSTICS = 'trends-diagnostics';
const CREATE_FILTER = 'create-filter';
const DRILLDOWN_LIMIT = 'drilldown-level'; // number of ANDs in a filter
const SECONDARY_TIME_SERIES = 'secondary-time-series';
const TRENDS_DIAG_COMPARE_SERIES = 'trends-compare-series';
const EXPORT_DATA = 'export-data';
const EXPORT_WIDGET_DATA = 'export-widget-data';
const SHOW_CONTAINS = 'show_contains_operator';
const CUSTOMER_ACCOUNT_TYPE = 'customer_account_type';
const NOC = 'noc';
const MINUTE_GRANULARITY = 'metric-panel-minute-granularity';
const DEFAULT_LANDING_PAGE = 'default_landing_page_enabled';
const NEXA_UNIFIED = 'nexa-unified';
const NEXA_CONTEXT_CENTER = 'nexa-context-center';
const ML = 'metric-lens';
const ML_SHARE = 'ml-share';
const ML_SAVE = 'ml-save';

const NOC_AD_HOC = 'noc-ad-hoc';
const NON_BLOCKING_LOADER = 'trends-non-blocking-loader';

const NOC_SHARE = 'noc-share';
const NOC_SAVE = 'noc-save';

const OVB_SHARE = 'ovb-share';
const OVB_SAVE = 'ovb-save';

const REALTIME_MAX_FILTERS = 'realtime-max-filters';
const REALTIME_ROWS_PER_DIMENSION = 'realtime-rows-per-dimension';
const REALTIME_AI_THRESHOLD = 'realtime-ai-threshold';
const NEW_TRENDS_LAYOUT = 'new-trends-layout';
const NOC_BUSINESS_ERROR_METRICS = 'business-error-metrics-for-realtime';
const EXPERIENCE_DASHBOARD = 'overview-dashboard';
const EXPERIENCE_DASHBOARD_BENCHMARK = 'overview-dashboard-benchmark';
const EXPERIENCE_DASHBOARD_ADVANCED_BENCHMARK = 'advanced-benchmark';
const TLB_CUTOVER_DATE = 'tlb-cutover-date';
const AUTO_RETRY = 'auto-retry';
const SI_BIGPANDA = 'service-integration-bigpanda';
const SI_DATADOG = 'service-integration-datadog';
const METRIC_SELECTOR_POPUP = 'metric-selector-popup';
const AI_ALERTS_CUSTOM_METRICS_LIMIT = 'ai-alerts-custom-metric-limit';
const AI_ALERTS_CUSTOM_METRICS_NOTIFICATIONS = 'ai-alerts-custom-metrics-notifications';
const APP_AI_ALERTS = 'app-ai-alerts';
const PRECISION_POLICY_SCHEDULING = 'precision-policy-scheduling';
const CAN_EDIT_PRECISION_POLICY_FILTER = 'can-edit-precision-policy-filter';
const AI_ALERTS_PCP = 'ai-alerts-pcp';
const AI_ALERT_FUSION_VSI = 'ai-alert-fusion-vsi';
const MUTE_AI_ALERT_NOTIFICATIONS = 'mute-ai-alert-notifications';
const AI_ALERT_NOTIFICATION_RULES = 'ai-alert-notification-rules';
const AI_ALERTS_CIRR = 'ai-alerts-cirr';
const AI_ALERTS_1_MIN_PERSISTENCE = 'ai-alert-one-min-persistence';
const IS_AI_ALERT_FORWARDING_PARTNER = 'is_alert_forwarding_partner';
const AI_ALERTS_CUSTOM_DIMENSIONS_UPPER_LIMIT = 'ai-alerts-custom-dimensions-upper-limit';
const SESSION_TIMELINE_30DAYS_SAVE = 'session-timeline-30days-save';
const RESILIENCY = 'resiliency';
const DPI_OVERVIEW = 'dpi-overview';
const SESSION_TIMELINE_WITH_FLOW = 'session-timeline-with-flow';

const BROKEN_ASSETS = 'broken-assets';
const NEWAPP_VERSION = 'newapp-version';

const KPI_DROPDOWN = 'kpi-dropdown';
const TIME_GRANULARITY = 'time-granularity';

const RT_ON_TRENDS_LAST_15 = 'rt-on-trens';

const VM_LIVE_TLB = 'vm-live-tlb';

const CONTRACT_LEVEL_USAGE_DASHBOARD = 'contract-level-usage-dashboard';
const PROMPT = 'prompt';

const ODP_METRICS = 'odp_metrics';
const STREAM_METADATA_ACCOUNT = 'stream-metadata-account';
const PULSE4_API_USAGE = 'pulse4-api-usage';
const SHOW_API_USAGE_BREAKDOWN = 'show-api-usage-breakdown';
const SHOW_USER_NAME_BREAKDOWN = 'show-user-name-breakdown';
const API_KEY_LIMIT = 'api-key-limit';
const TLB_VERSION = 'tlb-version';
const METRIC_HELP = 'metric-help';
const AUTO_Y_AXIS = 'auto-y-axis';
const PERSONAL_PRESETS = 'enableVideoPersonalPresets';
const DPI_OOB_RAGE_CLICKS = 'dpi-oob-rage-click';
const DPI_OOB_PAGE_LOOPING = 'dpi-oob-page-loop-metrics';
const DPI_OOB_CLICK_TO_WEB_ERROR = 'dpi-oob-click-error-metrics';
const DPI_OOB_EXCESSIVE_APP_RESTART = 'dpi-oob-excessive-app-restart';
const DPI_FRUSTRATION_SIGNALS = 'dpi-oob-frustration-signal';
const DPI_EXCLUDE_MOBILE_META = 'dpi-exclude-mobile-meta';
const DPI_NEXA_PI_SUMMARY = 'dpi-nexa-pi-summary';

// New Filter Dialog FF.
// Will be deprecated after new filter dialog GA.
const NEW_FILTER_BUILDER = 'new-filter-builder';

const WIDGET_PANEL = 'widget-panel';
const RT_TRENDS_REFRESH_RATE = 'rt-trends-refresh-rate';

const NEW_BROWSER_TAB_WORKFLOW = 'new-browser-tab-workflow';

const MGW_SAMPLING_CUTOVER_DATE = 'mgw-sampling-cutover-date';
const GW_THROTTLING_START_DATE = 'gw-throttling-start-date';

const DPI_FLOW_TOP_BAR = 'dpi-flow-top-bar';

const SSD = 'ssd_enabled';
const SESSION_TAG = 'session_tag_enabled';

const featureNamesMap = {
  EI: {
    METRICS,
    VIEWER_DRILLDOWN,
    VIEWER_DRILLDOWN_DISTRIBUTION,
    VIEWER_DRILLDOWN_REST_METRICS,
    DISTRIBUTION_METRICS,
    DISTRIBUTION_METRICS_DRILLDOWN,
    VIEWER_DRILLDOWN_TIMELINE,
    AI_ALERTS,
    DISABLE_THRESHOLD,
    BUSINESS_ERROR_CONFIG,
    NOC_BUSINESS_ERROR_METRICS,
    ML,
    ML_SAVE,
    ML_SHARE,
    EXPERIENCE_DASHBOARD,
    EXPERIENCE_DASHBOARD_BENCHMARK,
    EXPERIENCE_DASHBOARD_ADVANCED_BENCHMARK,
    UNIFIED_AD_CONTENT_OVERVIEW,
    SI_BIGPANDA,
    SI_DATADOG,
    PRECISION_POLICY_SCHEDULING,
    CAN_EDIT_PRECISION_POLICY_FILTER,
    ENABLE_2019_CHANGES,
    SHOW_NINETY_DAYS_HISTORY,
    VIEWER_MODULE_PULSE5,
    AUTO_INSIGHTS,
    BROKEN_ASSETS,
    AI_ROADMAP,
    AI_ALERTS_CUSTOM_DIMENSIONS_UPPER_LIMIT,
    VIEWERS_OVERVIEW,
    VIEWERS_BROWSER_TAB,
    NEWAPP_VERSION,
    KPI_DROPDOWN,
    SESSION_TIMELINE_30DAYS_SAVE,
    VM_LIVE_TLB,
    REALTIME_PSD,
    EI_PAGERDUTY,
    RESILIENCY,
    VIEWER_MODULE_AI_SUMMARY,
    MGW_SAMPLING_CUTOVER_DATE,
    GW_THROTTLING_START_DATE,
    NEXA: NEXA_EI,
    SSD,
    SESSION_TAG,
  },
  AI: {
    METRICS: AD_METRICS,
    AI_ALERTS: AD_AI_ALERTS,
    DISABLE_THRESHOLD: AD_DISABLE_THRESHOLD,
    // Below features are not avaialble for AI
    // flags are not defined in portal, defaults to false
    VIEWER_DRILLDOWN: AD_VIEWER_DRILLDOWN,
    VIEWER_DRILLDOWN_DISTRIBUTION: AD_VIEWER_DRILLDOWN_REST_METRICS,
    VIEWER_DRILLDOWN_REST_METRICS: AD_VIEWER_DRILLDOWN_DISTRIBUTION,
    DISTRIBUTION_METRICS: AD_DISTRIBUTION_METRICS,
    DISTRIBUTION_METRICS_DRILLDOWN: AD_DISTRIBUTION_METRICS_DRILLDOWN,
    VIEWER_DRILLDOWN_TIMELINE: AD_VIEWER_DRILLDOWN_TIMELINE,
  },
  APP: {
    METRICS: APP_METRICS,
    APP_EXPERIENCE,
    APP_USER_TIMELINE,
    APP_EXPERIENCE_BACKEND,
    APP_RT_ON_TRENDS,
    APP_EXPERIENCE_SAVE_AND_SHARE,
    APP_INSIGHTS_DISTRIBUTION,
    APP_INSIGHTS_METRIC_FILTERING,
    CREATE_FILTER: APP_CREATE_FILTER,
    TOP_RISING_CONTENT: APP_TOP_RISING_CONTENT,
    KPI_DROPDOWN,
    DRILLDOWN_LIMIT: APP_DRILLDOWN_LIMIT,
    APP_AI_ALERTS,
    APP_SPI,
    AUDIENCE_ENGAGEMENT_METRICS,
    REALTIME_PSD,
    DISABLE_THRESHOLD: APP_DISABLE_THRESHOLD,
    DECODED_STACK_TRACE,
    ECO_NETWORK_REQUEST_RCA,
    DATA_ACCESS_DURATION: ECO_DATA_ACCESS_MONTHS,
    ECO_AI_ALERT_2,
    DPI_AI_ALERTS_CUSTOM_DIMENSIONS_PER_METRIC_LIMIT,
    SELF_SERVE,
    SELF_SERVE_INTEGRATION_STATUS,
    DPI_OVERVIEW,
    NEXA: NEXA_APP,
    ECO_AI_ALERT_MINS_WITH_X_METRICS,
    DPI_FLOW_TOP_BAR,
    DPI_OOB_RAGE_CLICKS,
    DPI_OOB_CLICK_TO_WEB_ERROR,
    DPI_OOB_EXCESSIVE_APP_RESTART,
    DPI_OOB_PAGE_LOOPING,
    DPI_FRUSTRATION_SIGNALS,
    SESSION_TIMELINE_WITH_FLOW,
    DPI_EXCLUDE_MOBILE_META,
    DPI_NEXA_PI_SUMMARY,
  },
  ODP: {
    METRICS: ODP_METRICS,
    MINI_ODP_ACCESS: 'mini_odp_access',
  },
};

const commonFeatureNames = {
  NEXA_CONTEXT_CENTER,
  NEXA_VIEWER,
  CUSTOM_TAGS,
  ERROR_DIAGNOSTICS,
  DAY_OVER_DAY,
  SAVED_DASHBOARDS,
  SHARE,
  COMPARE,
  COMBINATORIAL_FILTER,
  ENUMERATED_VALUES_PER_DIMENSION,
  DATA_ACCESS_DURATION,
  ERROR_CODES_LIMIT,
  TRENDS_DIAGNOSTICS,
  CREATE_FILTER,
  DRILLDOWN_LIMIT,
  SECONDARY_TIME_SERIES,
  TRENDS_DIAG_COMPARE_SERIES,
  EXPORT_DATA,
  EXPORT_WIDGET_DATA,
  SHOW_CONTAINS,
  CUSTOMER_ACCOUNT_TYPE,
  NOC,
  REALTIME_MAX_FILTERS,
  REALTIME_ROWS_PER_DIMENSION,
  REALTIME_AI_THRESHOLD,
  MINUTE_GRANULARITY,
  DEFAULT_LANDING_PAGE,
  NEXA_UNIFIED,
  ALERT_DIAGNOSTICS,
  NOC_AD_HOC,
  NON_BLOCKING_LOADER,
  NOC_SHARE,
  NOC_SAVE,
  TOP_RISING_CONTENT,
  NEW_TRENDS_LAYOUT,
  TLB_CUTOVER_DATE,
  AUTO_RETRY,
  OVB_SHARE,
  OVB_SAVE,
  TIME_GRANULARITY,
  RT_ON_TRENDS_LAST_15,
  HORIZONTAL_LAYOUT,
  METRIC_SELECTOR_POPUP,
  ANNOTATIONS,
  PUBLIC_SAVED_DASHBOARDS,
  ALL_METRICS,
  CONTRACT_LEVEL_USAGE_DASHBOARD,
  PROMPT,
  DISPLAY_PAGERDUTY_IN_SI,
  ODP_METRICS,
  STREAM_METADATA_ACCOUNT,
  // not required in common anymore
  APP_AI_ALERTS,
  AI_ALERTS_CUSTOM_METRICS_LIMIT,
  AI_ALERTS_CUSTOM_METRICS_NOTIFICATIONS,
  AI_ALERTS_PCP,
  AI_ALERT_FUSION_VSI,
  MUTE_AI_ALERT_NOTIFICATIONS,
  AI_ALERT_NOTIFICATION_RULES,
  IS_AI_ALERT_FORWARDING_PARTNER,
  AI_ALERTS_CIRR,
  AI_ALERTS_1_MIN_PERSISTENCE,
  BUSINESS_ERROR_METRIC,
  PULSE4_API_USAGE,
  SHOW_API_USAGE_BREAKDOWN,
  SHOW_USER_NAME_BREAKDOWN,
  API_KEY_LIMIT,
  NEW_FILTER_BUILDER,
  METRIC_HELP,
  TLB_VERSION,
  WIDGET_PANEL,
  RT_TRENDS_REFRESH_RATE,
  AUTO_Y_AXIS,
  PERSONAL_PRESETS,
  NEW_BROWSER_TAB_WORKFLOW,
  SSD,
  SESSION_TAG,
};

const DPI_CUSTOM_DIMENSION = 'enableDPIAIAlertCustomDimension';
const DPI_ALERT_PAGINATION = 'enableDPIAIAlertSummaryPagination';
const IS_PCP_FROM_NEW_SYSTEM = 'isPCPFromNewSystem';

export const globalFeatureNames = {
  DPI_CUSTOM_DIMENSION,
  DPI_ALERT_PAGINATION,
  IS_PCP_FROM_NEW_SYSTEM,
};

const featureNames: any = Object.assign({}, commonFeatureNames, featureNamesMap[product]);

export const usageDashboardFeatureNames = {
  VSI_DATA_ACCESS_DURATION: DATA_ACCESS_DURATION,
  DPI_DATA_ACCESS_DURATION: ECO_DATA_ACCESS_MONTHS,
};

export default featureNames;
